import {Component} from '@angular/core';
import {IdentityService} from 'src/app/identity/identity.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {
    constructor(
        public identity: IdentityService
    ) {
        this.identity.login();
    }
}
